import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';
import { Button, message } from '@tencent/tea-component';
import CheckBeforePublish, {
  DashboardEventCheckBeforePublishRes,
} from '@quickService/DashboardEventCheckBeforePublish';
import { unPublishActivity } from '@utils/activity-card-option';
import { useStore, ACTION } from '@utils/event-store/useEventData';
import dataReport from '@utils/data-report';
import { getRealNameAlertInfo, realNameVerifyModal } from '@component/RealNameModal';
import useNameAuth from '@hooks/useNameAuth';
interface PublishParams {
  type?: 'primary' | 'text' | 'weak' | 'pay' | 'error' | 'link' | 'icon' | undefined;
  disabled?: boolean;
  text?: string;
  classNames?: string;
  reportCode?: string;
}

const PublishBtn = (params: PublishParams) => {
  const {
    type = 'primary',
    disabled = false,
    text = '发布',
    classNames = 'size-xs',
    reportCode,
  } = params;
  const router = useRouter();
  const { query } = router;
  const eventId = query.eventid as string;
  const { eventInfo, dispatch, showPublishTip, closePublishTip, showCanPublishTip } = useStore();
  const [btnLoading, setBtnLoading] = useState(false);
  const { checkNameAuth } = useNameAuth();

  // 取消发布
  const unPublish = () => {
    unPublishActivity({ event_id: eventId }, (res: { code: number }) => {
      res?.code === 0 && dispatch({ type: ACTION.UPDATEINFOREEDIRTSTATUS, data: eventId });
    });
  };

  const publish = useCallback(() => {
    if (reportCode) dataReport(reportCode);
    if (
      eventInfo?.status === 0 ||
      eventInfo?.status === 3 ||
      eventInfo?.status === 5 ||
      (eventInfo?.status === 1 && eventInfo?.reedit_status === 1)
    ) {
      if (checkNameAuth() === false) return; // 到期未实名认证，直接拦截返回
      setBtnLoading(true);
      const next = (res: DashboardEventCheckBeforePublishRes) => {
        dispatch({
          type: ACTION.UPDATEDATA,
          data: {
            errorInfo: res?.data?.items || [],
            warnItems: res?.data?.warning_items || [],
            errorItemsSort: res?.data?.items_sort,
            showPublishDialog: true,
          },
        });
      };
      CheckBeforePublish({ event_id: eventId })
        .then((res) => {
          if (res?.code === 0) {
            // 没有实名
            if (res?.data?.real_name_verify_info?.code === 1) {
              realNameVerifyModal({
                onNotVerify: () => next(res),
                onVerifySuccess: () => next(res),
                alertInfo: getRealNameAlertInfo(res?.data?.real_name_verify_info),
              });
            } else {
              next(res);
            }
          } else {
            return Promise.reject(res?.msg || res?.err_detail);
          }
        })
        .catch(err => {
          message.error({ content: err });
        })
        .finally(() => {
          setBtnLoading(false);
        });
    }
    if (eventInfo?.status === 2) {
      unPublish();
    }
  }, [eventInfo?.status, eventId, eventInfo?.reedit_status, checkNameAuth]);

  return (
    <Button
      className={classNames}
      type={type}
      onClick={() => {
        dataReport('e#event_navigation#publish_button#click');
        publish();
        closePublishTip(showPublishTip, showCanPublishTip);
      }}
      disabled={disabled}
      loading={btnLoading}
    >
      {text}
    </Button>
  );
};

export default PublishBtn;
